export default "__VITE_ASSET__Dic7Jy0z__"